import React, { Component } from 'react';
import Item from './components/Item/Item';
import './style.scss';
import { connect } from 'react-redux'
import { showModal, MODAL_PRESENTATION_FORM, MODAL_SLIDER_FORM } from '../../../../modules/modals';
import {getFolderSlider } from '../../actions';
import Spiner from '../../../helpers/Spiner/Spiner';
import { getParams } from '../../../PresentationsStart/actions';

class PresentationItems extends Component {
  state = {
    urlApi: '',
    site: ''
  };
  componentDidMount = async () => {
    const {folder} = this.props;
    const params = await getParams();
    this.setState({
      urlApi: params.presentationApi,
      site: params.presentationSite,
    })
    if(folder && folder.id){
      this.props.getFolderSlider(folder.id);
    }
    
  }
  render() {
    const {sliders, sliders_loaded, folder} = this.props;
    const {urlApi, site} = this.state;
    return (
      <div className="question-container PresentationItems">
        <div className="question-types-block">
          {folder && <div className="actions">
            <div className="add-present" onClick={() => {
              const { showModal } = this.props;
              showModal({
                modalType : MODAL_SLIDER_FORM,
                modalProps : {
                  initialValues: {}
                }
              });
            }}><i className="fas fa-plus"></i></div>
          </div>}
          <div className="col-md-12">
            {!sliders_loaded && <Spiner />}
            {sliders_loaded && sliders.map(item => <Item 
              siteUrl={site} urlApi={urlApi} key={'slider-' + item.id} showModal={this.props.showModal} slider={item} />)}
          </div>
        </div>
      </div>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
  sliders: state.slider_folders.sliders,
  sliders_loaded: state.slider_folders.sliders_loaded,
  folder: state.slider_folders.item,
})

const mapDispatchToProps = {
  showModal,
  getFolderSlider
}

export default connect(mapStateToProps, mapDispatchToProps)(PresentationItems)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Sliders/components/PresentationItems/PresentationItems.jsx